import axios from 'axios';

// Get the backend URL from environment variables
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token(s) to requests if available. Admin (Authorization) and
// player (X-Player-Token) sessions are independent — both may be attached
// to the same request if both happen to be present in this browser.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const playerToken = localStorage.getItem('playerToken');
  if (playerToken) {
    config.headers['X-Player-Token'] = playerToken;
  }
  return config;
});

// Handle auth errors. A 401 is scoped to whichever identity the failing
// request actually targets — an expired player session must not force an
// admin logout/redirect, and vice versa. Both tokens may be attached to the
// same request (e.g. an admin session open in one tab and a player session
// in another both write to this browser's localStorage), so the failing
// request's URL — not header presence — decides which session failed.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isPlayerRequest = error.config?.url?.startsWith('/players/');
      if (isPlayerRequest) {
        localStorage.removeItem('playerToken');
        localStorage.removeItem('playerAuth');
      } else {
        localStorage.removeItem('authToken');
        localStorage.removeItem('adminAuth');
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;